import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CVApiService } from '../../../reusables/services/cv-api.service';
import { UserAdminService } from '../user-admin.service';

@Component({
    selector: 'cv-image-upload',
    templateUrl: './image-upload.component.html',
    styleUrls: ['./image-upload.component.scss']
})
export class ImageUploadComponent implements OnInit {

    @Output() croppedImage: EventEmitter<string> = new EventEmitter<string>();
    @Output() close: EventEmitter<void> = new EventEmitter<void>();

    public _croppedImg: string = "";

    constructor(
        private uaService: UserAdminService
    ) { }

    ngOnInit(): void {
    }

    updateCroppedImage(img: string) {
        this._croppedImg = img;
    }

    saveDisabled() {
        return !this._croppedImg || this._croppedImg.trim() == "";
    }

    updateUserImage() {
        this.croppedImage.emit(this._croppedImg);
        this.close.emit();
    }

    imageCancel() {
        this.close.emit();
    }
}
